import React from 'react';

const CashEventRadioButton = ({ events = [] }) => {
  return (
    <div>
      {events.map((event) => (
        <div key={event.id}>
          <label
            className={`inline-block mb-1.5 lg:mb-0 ${!event.is_applicable ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="inline-block align-middle lg:hidden me-1">
              <input
                id={`option${event.id}`}
                type="radio"
                name="point_type"
                value={event.name}
                className="peer hidden"
                disabled={!event.is_applicable}
              />
              <label
                htmlFor={`option${event.id}`}
                className="relative block w-5 h-5 cursor-pointer rounded-md mobile-radio-bg bg-[length:200px_200px] bg-[176px_22px] peer-checked:bg-[-22px_0]"
              />
            </div>
            <input
              type="radio"
              name="point_type"
              value={event.name}
              className="hidden lg:inline-block"
              disabled={!event.is_applicable}
            />
            <span style={{ marginLeft: '0.5em' }}>
              {event.name} - <span className="text-[#ffff48]">{event.description}</span>
              {!event.is_applicable && <span className="text-gray-400 ml-2">(신청 불가)</span>}
            </span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default CashEventRadioButton;
